import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import './styles.css';

const InspectionCard = ({ items }) => {
  return (
    <Box className="dashboard-card" sx={{ 
      p: 2.5, 
      borderRadius: 1.5, 
      boxShadow: '0 3px 5px rgba(0, 0, 0, 0.1)',
      bgcolor: 'background.paper',
      mb: 2
    }}>
      <Grid container spacing={0.5}>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <Grid item xs={12}>
              <Box py={1.2} display="flex" justifyContent="space-between" alignItems="center">
                <Typography className="metric-label" variant="body2" color="text.secondary">
                  {item.label}
                </Typography>
                <Typography className="metric-value padded" variant="body2" fontWeight="medium">
                  {item.value.toString().padStart(2, '0')}
                </Typography>
              </Box>
            </Grid>
            {index < items.length - 1 && (
              <Grid item xs={12}>
                <div className="divider" />
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
};

export default InspectionCard; 